import { isDocumentFoundation, } from '@debbie/common/dist/documents/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Badge from '../Badge.js';
import { CheckCircle, Eye, Shield } from '../Icons/index.js';
export const DocumentTypeBadge = ({ document }) => {
    const lang = useSelector((s) => s.lang);
    return React.createElement(Badge, { theme: "lightgrey" }, lang.documentTypes[document.type]);
};
export const DocumentSignedIcon = ({ document }) => {
    const lang = useSelector((s) => s.lang);
    return document.signedAt ? (React.createElement(SignedIcon, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.documentSigned })) : null;
};
export const DocumentFoundationIcon = ({ document }) => {
    const lang = useSelector((s) => s.lang);
    return isDocumentFoundation(document) ? (React.createElement(FoundationIcon, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.isFoundation })) : null;
};
export const DocumentVisibilityIcon = ({ document }) => {
    const lang = useSelector((s) => s.lang);
    return document.minAccessRole === 'debtor' ? (React.createElement(VisibilityIcon, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.visibleForDebtor })) : null;
};
const SignedIcon = styled(CheckCircle) `
  color: #3b92d3;
`;
const FoundationIcon = styled(Shield) `
  color: #3b92d3;
`;
const VisibilityIcon = styled(Eye) `
  color: #3b92d3;
`;
//# sourceMappingURL=DocumentIndicators.js.map